export default function TraceInventoryArea(props) {
  const { inventory } = props;
  const inventoryRows = Array.isArray(inventory)
    ? inventory
    : inventory
      ? [inventory]
      : [];

  const totals = inventoryRows.reduce(
    (acc, row) => {
      acc.inStock += Number(row?.inventory_in_stock ?? 0);
      acc.sold += Number(row?.inventory_sold ?? 0);
      acc.packaged += Number(row?.total_packaged ?? 0);
      return acc;
    },
    { inStock: 0, sold: 0, packaged: 0 },
  );

  return (
    <div>
      <h3 className="text-lg mb-2 px-1">Inventory</h3>
      <div className="overflow-hidden bg-white">
        {inventoryRows.length === 0 ? (
          <div className="p-4 text-gray-500">No inventory records.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">
                    Product
                  </th>
                  <th className="px-4 py-2 text-right font-semibold text-gray-700">
                    In Stock
                  </th>
                  <th className="px-4 py-2 text-right font-semibold text-gray-700">
                    Sold
                  </th>
                  <th className="px-4 py-2 text-right font-semibold text-gray-700">
                    Total Packaged
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 bg-white">
                {inventoryRows.map((row, idx) => (
                  <tr key={`${row?.plu ?? "inventory"}-${idx}`}>
                    <td className="px-4 py-2 text-gray-900">
                      <div className="font-medium">
                        {row?.product_name ?? "—"}
                      </div>
                      <div className="text-xs text-gray-500">
                        PLU: {row?.plu ?? "—"}
                      </div>
                    </td>
                    <td className="px-4 py-2 text-right text-gray-900">
                      {row?.inventory_in_stock ?? 0}
                    </td>
                    <td className="px-4 py-2 text-right text-gray-900">
                      {row?.inventory_sold ?? 0}
                    </td>
                    <td className="px-4 py-2 text-right text-gray-900">
                      {row?.total_packaged ?? 0}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-gray-50">
                <tr>
                  <td className="px-4 py-2 font-semibold text-gray-900">
                    Totals
                  </td>
                  <td className="px-4 py-2 text-right font-semibold text-gray-900">
                    {totals.inStock}
                  </td>
                  <td className="px-4 py-2 text-right font-semibold text-gray-900">
                    {totals.sold}
                  </td>
                  <td className="px-4 py-2 text-right font-semibold text-gray-900">
                    {totals.packaged}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
      <div className="mt-2 text-xs text-gray-500">
        Inventory summary by packaged PLU for this production lot.
      </div>
    </div>
  );
}
